import AboutPage, { getServerSideProps } from 'pages/[lang]/about';

export default AboutPage;

export { getServerSideProps };
